import { IPolledDevicesGridCell } from "../../../services/summary-listing-data-service/DeviceSummaryModels";

export function memoTextComparator(valueA: IPolledDevicesGridCell, valueB: IPolledDevicesGridCell) {

    return valueA?.displayText.localeCompare(valueB?.displayText, undefined, { sensitivity: "base" });
}
